import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ErrorModal from '../../../components/errorModal';
import { API_ENDPOINT } from '../../../constants';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { getHumanReadablePaymentMethod } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class RegisterPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            }
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        let form = {
            paymentId: paymentData?._id ?? null,
            reference: '',
            paymentMethod: '',
            paymentMethodString: ''
        };
        const requestedInvoice = paymentData?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
        const attachedInvoiceExists = paymentData?.attachedInvoice && requestedInvoice ? true : false;
        const requestedPaymentOnSite = paymentData?.currentStatus?.paymentMethod?.key === 'paymentOnSite' ? true : false;
        if (attachedInvoiceExists) {
            form.paymentMethod = 'invoice';
        } else if (requestedPaymentOnSite) {
            form.paymentMethod = 'paymentOnSite';
        }
        if (form.paymentMethod) {
            form.paymentMethodString = getHumanReadablePaymentMethod(form.paymentMethod, this.props.lang);
        }

        this.setState({ form, currency })
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                if (!payment || payment?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }




    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }

        const data = {
            reference: form.reference,
            paymentMethod: form.paymentMethod
        }


        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/register-payment/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingUpdate: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};
        if (!form?.reference || !form?.reference.trim()) {
            errors.reference = 'Reference is required'.translate(this.props.lang);
        }

        return Object.keys(errors).length ? errors : null;
    }

    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const errors = this.state.errors ?? {};

        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Register payment'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>

                            <Col lg='12'>
                                <FormGroup>
                                    <Label>{'Payment method'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={this.state.form?.paymentMethodString}
                                        disabled={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg='12'>
                                <FormGroup className={errors.reference ? 'fg-has-error' : ''}>
                                    <Label>{'Reference'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={this.state.form?.reference}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            let form = this.state.form;
                                            form.reference = value;

                                            let setObj = { form };
                                            if (this.state.errors?.reference) {
                                                let errors = this.state.errors;
                                                delete errors.reference;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    />
                                    {errors.reference ? <div className='error-feedback'>{errors.reference}</div> : null}
                                </FormGroup>
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingUpdate || !this.state.form?.reference}
                        >
                            {'Save'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>

                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}

            </>
        );
    }
}


export default RegisterPayment;